<template>
  <l-cache ref="cache" :get-data="getItem" :id="id">
    <RuleTemplate slot-scope="{data}" :form-data="data" :status-prop="$route.query.status"></RuleTemplate>
  </l-cache>
</template>
<script>
import RuleTemplate from './ruleTemplate'
export default {
  components: {RuleTemplate},
  data () {
    return {
      id: ''
    }
  },
  created () {
    if (this.$route.query.id === '') {
      this.id = 'newTemplate'
    }
    else {
      this.id = this.$route.query.id
    }
  },
  methods: {
    async getItem (key) {
      if (this.$route.query.status === 'new') {
        let data = {}
        return data
      }
      else {
        let params = {pagination: {page: 1, rowsPerPage: 10}, search: {key: 'id', value: this.$route.query.id}}
        let {items} = await this.$store.dispatch('charging/getRuleTemplateList', params)
        return items[0]
      }
    }
  },
}
</script>
